import React, { useEffect } from "react";
import { useAppSelector } from "../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../facade/collapse.Facade";
import Accordion from "../accordion";

const ProjectSummary: React.FC = () => {
    const { GasCalculationOutPut } = useAppSelector((state) => state?.gasCalculations);
    const { projectSummaryCollapse } = useAppSelector((state) => state?.collapse);
    const { basicTDHCalculation } = useAppSelector((state) => state?.basicCalculations);
    const selectedPump = useAppSelector((state) => state?.pump?.SelectedPump);
    const selectedMotor = useAppSelector((state) => state?.motor?.SelectedMotor);
    const PumpInputData = useAppSelector((state) => state?.pump.PumpInput);
    const PercentageShaftRating = useAppSelector((state) => state?.protector?.shaftPercentate);
    const CableVDrop = useAppSelector((state) => state?.cable.cableVDrop);
    const CableSelected = useAppSelector((state) => state?.cable?.selectedCable);
    const GasCalulcation = useAppSelector((state) => state?.gasCalculations?.BasicGasCalculation);
    const [summaryDetail_GVF_MainPump, setSummaryDetail_GVF_MainPump] = React.useState('');
    const totalSystemTDH = useAppSelector((state) => state?.summary?.totalSystemTDH);
    const shaftPercentageLoad = useAppSelector((state) => state?.pump?.FetchShaftPercentageLoad);
    const motorperformanceList = useAppSelector((state) => state?.motor?.MotorperformanceList);
    const thrustPercentage = useAppSelector((state) => state?.protector?.thrustPercentage);
    const FetchSwitchControllerLoad = useAppSelector((state) => state?.surfaceEquipment?.FetchSwitchControllerLoad);
    const { tab1Input } = useAppSelector((state) => state?.tubing);
    const SelectedVSD = useAppSelector((state) => state?.surfaceEquipment?.SelectedVSD);
    const SelectedSwitchBoard = useAppSelector((state) => state?.surfaceEquipment?.SelectedSwitchBoard);
    const vsdPercentage = useAppSelector((state) => state?.surfaceEquipment?.FetchVSDControllerLoad);
    useEffect(() => {
        if (GasCalculationOutPut && Object?.keys(GasCalculationOutPut)?.length > 0) {
            const gasOutput = GasCalculationOutPut && Object?.keys(GasCalculationOutPut)?.length > 0 ? GasCalculationOutPut : null;
            var freeGas_pump = gasOutput?.CP3_FreeGas?.toString() ?? gasOutput?.CP2_FreeGas?.toString() ?? gasOutput?.CP1_FreeGas?.toString() ?? '';
            const selectedchargePump1 = GasCalulcation?.chargePump
            const selectedchargePump2 = GasCalulcation?.chargePump2;
            const selectedchargePump3 = GasCalulcation?.chargePump3;
            const selectedChargePumpGKX = GasCalulcation?.chargePumpGKX;
            var isGasChargePumpsVisible = !isInValid(selectedchargePump1 ?? '') || !isInValid(selectedchargePump2 ?? '') || !isInValid(selectedchargePump3 ?? '');
            var isGKXVisible = !isInValid(selectedChargePumpGKX ?? '');
            var freeGas_GKX = gasOutput?.GKX_FreeGas?.toString() ?? '';
            var freeGas_Seperator = gasOutput?.SP4_FreeGas?.toString() ?? gasOutput?.SP3_FreeGas?.toString() ?? gasOutput?.SP2_FreeGas?.toString() ?? gasOutput?.SP1_FreeGas?.toString() ?? '';
            var gvfVal;
    
            if (isGasChargePumpsVisible && freeGas_pump)
                gvfVal = freeGas_pump;
            else if (isGKXVisible && freeGas_GKX)
                gvfVal = freeGas_GKX;
            else
                gvfVal = freeGas_Seperator;
    
            setSummaryDetail_GVF_MainPump(`${gvfVal || ''} ${GasCalulcation?.actNameGas_FreeGas || '%'}`);
        }
        return () => {};
    }, [GasCalculationOutPut && Object?.keys(GasCalculationOutPut)?.length > 0, GasCalulcation]);

    const isInValid = (value: string) => {
        return value === undefined || value === null || value === "" || value === "0";
    };

    const { updateProjectSummaryCollapse } = useCollapseFacade();

    const handleCollapseChange = (key: boolean) => {
        updateProjectSummaryCollapse(key);
    };

    return (
        <div className="py-5">
            <Accordion
                title="Project summary"
                isOpen={projectSummaryCollapse}
                onToggle={() => handleCollapseChange(!projectSummaryCollapse)}
                content={
                    <>
                        <div className="grid grid-cols-6 gap-[8px] py-4 px-6 w-full bg-darkcolor-600 bg-opacity-50 rounded-b-[8px]">
                            <div className="flex flex-col">
                                <span className="text-neutral-25 text-[14px] font-normal">GVF at intake</span>
                                <span className="text-neutral-25 text-[18px] font-semibold">{GasCalculationOutPut?.Intake_FreeGas} %</span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-neutral-25 text-[14px] font-normal">Required system TDH</span>
                                <span className="text-neutral-25 text-[18px] font-semibold">
                                    {basicTDHCalculation?.systemTDH} {basicTDHCalculation?.actNameBasic_TubingHead || 'ft'}
                                </span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-neutral-25 text-[14px] font-normal">Main pump model</span>
                                <span className="text-neutral-25 text-[18px] font-semibold">
                                    {selectedPump?.pumpName} {PumpInputData?.pump_DesrdStges} stg
                                </span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-neutral-25 text-[14px] font-normal">Motor specification</span>
                                <span className="text-neutral-25 text-[18px] font-semibold">
                                    {selectedMotor?.name} - {selectedMotor?.size}/{selectedMotor?.voltage}/{selectedMotor?.current}
                                </span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-neutral-25 text-[14px] font-normal">Protector shaft load</span>
                                <span className="text-neutral-25 text-[18px] font-semibold">{PercentageShaftRating} %</span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-neutral-25 text-[14px] font-normal">Cable details / Motor NP ratio</span>
                                <span className="text-neutral-25 text-[18px] font-semibold">
                                {Number(CableVDrop) ? `${CableVDrop} %` : "%"} {typeof CableSelected === 'object' ? '' : CableSelected}
                            </span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-neutral-25 text-[14px] font-normal">GVF at main pump</span>
                                <span className="text-neutral-25 text-[18px] font-semibold">{summaryDetail_GVF_MainPump}</span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-neutral-25 text-[14px] font-normal">System lift TDH</span>
                                <span className="text-neutral-25 text-[18px] font-semibold">{totalSystemTDH} {basicTDHCalculation?.actNameBasic_TubingHead || 'ft'}</span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-neutral-25 text-[14px] font-normal">Pump shaft load</span>
                                <span className="text-neutral-25 text-[18px] font-semibold">{shaftPercentageLoad} %</span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-neutral-25 text-[14px] font-normal">Motor load</span>
                                <span className="text-neutral-25 text-[18px] font-semibold">{motorperformanceList[0]?.motorLoad} %</span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-neutral-25 text-[14px] font-normal">Protector bearing load</span>
                                <span className="text-neutral-25 text-[18px] font-semibold">{thrustPercentage} %</span>
                            </div>
                            {SelectedVSD && tab1Input?.hdnCntrlTyp === "0" && (
                                <div className="flex flex-col">
                                    <span className="text-neutral-25 text-[14px] font-normal">VSD load information</span>
                                    <span className="text-neutral-25 text-[18px] font-semibold">
                                        {vsdPercentage} % {SelectedVSD?.powerField} KVA / {SelectedVSD?.current_OutField} A
                                    </span>
                                </div>
                            )}
                            {SelectedSwitchBoard && tab1Input?.hdnCntrlTyp === "1" && (
                                <div className="flex flex-col">
                                    <span className="text-neutral-25 text-[14px] font-normal">Switchboard load information</span>
                                    <span className="text-neutral-25 text-[18px] font-semibold">
                                        {FetchSwitchControllerLoad} % {SelectedSwitchBoard?.voltage} V
                                    </span>
                                </div>
                            )}
                        </div>
                    </>
                }
            />
        </div>
    );
};

export default ProjectSummary;
